import { Fragment, useState } from 'react'
import { AssetReference } from '@opallabs/cassini'
import { Asset, kuiperClassNames } from '@opallabs/kuiper'
import { TwitterStreamFooter } from '../../../sharedDisplays/footers/TwitterStreamFooter'
import { TwitterStreamHeader } from '../../../sharedDisplays/headers/TwitterStreamHeader'
import { assetStyles } from '../../styles'

export interface Props {
  accountImage: AssetReference | null
  accountName: string
  accountUsername: string
  content: string
  display: string
  index: number
  isAccountPremium?: boolean
  isHovered: boolean
  isPresenting: boolean
  isSnapshot: boolean
  isThreaded: boolean
  modulesLength?: number
  onContentChange: (val: string) => void
  onExpandAsset: (assetId: number) => void
  onRemoveAsset: (assetId: number) => void
  postType: string
  readOnly: boolean
  video?: AssetReference
}

export const Stream: React.FC<Props> = ({
  accountImage,
  accountName,
  accountUsername,
  content,
  display = 'mobileStream',
  index,
  isAccountPremium,
  isHovered,
  isPresenting,
  isThreaded,
  modulesLength,
  onContentChange,
  onExpandAsset,
  onRemoveAsset,
  postType,
  readOnly,
  video,
}) => {
  const [duration, setDuration] = useState(1)

  return (
    <Fragment>
      <TwitterStreamHeader
        accountImage={accountImage}
        accountName={accountName}
        accountUsername={accountUsername}
        content={content}
        isAccountPremium={isAccountPremium}
        isMobile={display.includes('mobile')}
        isThreaded={isThreaded}
        index={index}
        postType={postType}
        modulesLength={modulesLength}
        onContentChange={onContentChange}
        readOnly={readOnly}
      />
      <div
        css={assetStyles.getAssetContainerStyles(display)}
        className={kuiperClassNames('twitter-video-asset-container')}
      >
        {video && (
          <Asset
            autoPlay={duration !== 0 && duration <= 6}
            videoLoop={duration !== 0 && duration <= 6}
            getDuration={(duration: number) => setDuration(duration)}
            imageFit="cover"
            isHovered={isHovered}
            hasAssetOverlay={Boolean(video) && (!readOnly || isPresenting)}
            assetReference={video}
            removeable={!isPresenting}
            hasAssetOptions={postType !== 'thread'}
            onEmbiggen={() => onExpandAsset(video.id || 0)}
            onRemove={() => onRemoveAsset(video.id || 0)}
            overrideStyles={assetStyles.getAssetStyles(video, display)}
          />
        )}
      </div>
      <TwitterStreamFooter isMobile={display.includes('mobile')} />
    </Fragment>
  )
}
